import React from 'react';
import { connect } from 'react-redux';
import StickyPrivate from './private';
import StickyAgent from './agent';
import StickyDeveloper from './developer';
import { makeContactMapStateToPropsFactory, ContactPoiGetter, poiSelector } from 'components/contact/makeContactMapStateToPropsFactory';
import { ContactUnionProps, ContactType } from 'components/contact/types';
import { PoiId, PocType } from 'utils/entities';
import { isBulletinPoiType, isProjectPoiType } from 'utils/marketplaceRoutes';
import withEvents from 'analytics/withEvents';
import { IContactPageSubmitVariables } from 'store/sagas/apiService/types';
import { getContactPageEventPayload, getPOCPhoneNumber, getProjectPhoneNumber } from 'helpers/contact';
import { ContactModalOpenMeta } from 'store/state/app';
import { Dispatch } from 'redux';
import { RootAction } from 'store/state';
import { setContactAgentOpen } from 'store/state/app/actions';

const poiByIdsSelector: ContactPoiGetter = (state) => poiSelector(state);

type GalleryStickyContactEntryProps = ContactUnionProps & {
  id: PoiId;
  onSetContactModalPoiId: (id: PoiId, meta: ContactModalOpenMeta) => void;
  onCallClickEvent?: (isVisible: boolean, formValues: IContactPageSubmitVariables, source?: string) => void;
};

const GalleryStickyContactEntry: React.FC<GalleryStickyContactEntryProps> = (props) => {
  if (!props) return null;


  switch (props.cardType) {
    case ContactType.Private:
      return <StickyPrivate {...props} />;
    case ContactType.Agent:
      return <StickyAgent {...props} />;
    case ContactType.Developer:
      return <StickyDeveloper {...props} />;
    default:
      return null;
  }
};

const GalleryStickyContactEntryWithEvents = withEvents<GalleryStickyContactEntryProps>((sendEvent, props) => ({
  onCallClickEvent: (isVisible: boolean, formValues: IContactPageSubmitVariables, source?: string) => {
    const contactDetails = getContactPageEventPayload(isBulletinPoiType(props.poi) && props.poi.poc, formValues, isVisible);
    const event = {
      ...contactDetails.event,
      ...(source ? { source } : null),
      ...('poc' in props.poi && props.poi.poc && props.poi.poc.type === PocType.Agent && !isVisible ? {
        agent_details: {
          id: props.poi.poc.agentId,
          office_id: props.poi.poc.officeId,
        },
      } : null),
    };

    sendEvent(isVisible ? 'property_lead_call_submit' : 'property_lead_phone_expose', 'property', {
      ...contactDetails,
      event,
      bulletinId: props.id,
      ...(isVisible ? {
        rtbData: {
          phone: isBulletinPoiType(props.poi) && getPOCPhoneNumber(props.poi.poc) || isProjectPoiType(props.poi) && getProjectPhoneNumber(props.poi),
        },
      } : null),
    });
  },
}))(GalleryStickyContactEntry);


const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onSetContactModalPoiId: (id: PoiId, meta: ContactModalOpenMeta) => dispatch(setContactAgentOpen(id, meta)),
});

const makeMapStateToProps = makeContactMapStateToPropsFactory(poiByIdsSelector);
const ConnectedGalleryStickyContactEntry = connect(makeMapStateToProps, mapDispatchToProps)(GalleryStickyContactEntryWithEvents);

export default ConnectedGalleryStickyContactEntry;
